<template>
  <v-col cols="12" md="12" sm="12" class="mx-auto register-form">
    <v-card class="ma-6 pa-3 mx-auto" rounded elevation="3" raised color="rgb(23,36,48,0.8)" max-width="600">
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="register">
        <v-col cols="12" md="12" sm="12">
          <v-img src="/img/fantasy_lineups_logo.png" width="400" class="mx-auto" />
        </v-col>

        <div align="center" class="mt-n5">
          <v-col cols="12" md="12" sm="12" align="center">
            <small class="body-1 green--text">Use your E-mail for registration.</small>
          </v-col>

          <!-- //* username -->
          <v-col cols="12" md="8" sm="8">
            <v-text-field class="input" v-model="form.userName" :counter="10" :rules="nameRules" label="User Name*"
              outlined filled required background-color="white"
              prepend-inner-icon="mdi-account-circle-outline"></v-text-field>
          </v-col>
        </div>

        <!-- //* email -->
        <div align="center" class="mt-n5">
          <v-col cols="12" md="8" sm="8">
            <v-text-field class="input" v-model.trim="form.email" :rules="emailRules" label="E-mail*" outlined filled
              required background-color="white" prepend-inner-icon="mdi-email-variant"></v-text-field>
          </v-col>
        </div>

        <!-- //* password -->
        <div align="center" class="mt-n5">
          <v-col cols="12" md="8" sm="8">
            <v-text-field class="input" v-model="form.password" :rules="passwordRules" label="Password*"
              :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword" outlined filled required background-color="white"
              prepend-inner-icon="mdi-form-textbox-password"></v-text-field>
          </v-col>

          <!-- //* button -->
          <v-col cols="12" md="8" sm="8" class="mt-n5">
            <v-btn block color="#73c604" type="submit" class="mr-4">
              <v-progress-circular v-if="getTeamLoader" indeterminate :width="5" color="primary"></v-progress-circular>
              Sign Up
            </v-btn>
          </v-col>
        </div>
        <v-col cols="12" md="12" align="center">
          <small class="body-2 font-weight-bold white--text">
            Already have account?
            <router-link to="/login" color="blue draken-2">Login</router-link>
            <!-- {{ ip.ip }} {{ region }} -->
          </small>
        </v-col>
      </v-form>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'SignUpForm',
  title: 'Fantasy Lineups Registration Page',
  props: ['payload'],

  data: () => ({
    valid: true,
    showPassword: false,
    snackbar: false,
    text: '',
    nameRules: [
      (v) => !!v || 'Name is required',
      (v) => (v && v.length <= 20) || 'Name must be less than 10 characters',
    ],
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    passwordRules: [
      (v) => v.length >= 6 || 'Min 6 characters',
      (v) =>
        (v &&
          /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}$/.test(v)) ||
        'Require combination of Uppercase & lowercase letters, Special(% & ^ ...) characters, Numeric(0-9).',
    ],

    checkbox: false,

    form: {
      email: '',
      password: '',
      userName: '',
    },
  }),

  computed: {
    ...mapGetters('NbaModule', ['getTeamLoader']),
    ...mapState('NbaModule', ['customerSession', 'user']),
    ...mapState('userModule', ['ip', 'region']),
  },

  // beforeRouteEnter(to, from, next) {
  //   if (!to.params.price_id) {
  //     next({name: 'Pricing'});
  //   } else {
  //     next();
  //   }
  // },

  created() {
    this.fetchUserInfo();
  },

  mounted() {
    this.GoogleAnalytic();
    this.GoogleAds();
  },

  methods: {
    GoogleAnalytic() {
      this.$gtag.config('UA-204063830-2');
      this.$gtag.pageview({ page_path: '/sign-up' });
    },

    GoogleAds() {
      this.$gtag.config('AW-323506423');
    },

    fetchUserInfo() {
      this.$store.dispatch('userModule/getUserIp').then(() => {
        this.$store.dispatch('userModule/getUserRegion', this.ip.ip);
      });
    },

    register() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        
          this.$store
            .dispatch('NbaModule/userRegister', {
              userName: this.form.userName,
              plantype: this.$route.params.planType
                ? this.$route.params.planType
                : '',
              email: this.form.email,
              password: this.form.password,
              paymentType: 'stripe',
              source: this.$route.query.utm_source,
              campaign: this.$route.query.utm_campaign,
              medium: this.$route.query.utm_medium,
              term: this.$route.query.utm_term,
              content: this.$route.query.utm_content,
              state: this.region,
              ip: this.ip.ip,
            })
            .then(() => {
              if (this.user.success) {
                localStorage.setItem('code', this.form.password);

                // Redirect all new users to Pricing page to choose their plan.
                // A plan already chosen there arrives as ?plan= and is resumed on arrival.
                const plan = this.$route.query.plan;
                const notification = {
                  type: 'success',
                  message: plan != null
                    ? 'Registration successful! Taking you to checkout.'
                    : 'Registration successful! Please choose a subscription plan to get started.'
                };
                this.$store.dispatch('notification/add', notification, { root: true });
                this.$router.replace({ name: 'Pricing', query: this.$route.query });
              } else {
                localStorage.clear();
              }
            });
      }
    },

    sendVerifyEmail() {
      let userID = this.$store.state.NbaModule.registerData.data._id;
      this.$store
        .dispatch('userModule/sendVerifyEmail', { userid: userID })
        .then(() => {
          this.$refs.form.reset();
          this.$router.push({ name: 'conversionPage' });
        });
    },
  },
};
</script>

<style scoped>
.input>>>input {
  color: rgba(0, 0, 0, 0.87);
  margin-top: 0px;
}

.btn-submit {
  background: #73c603;
  padding: 10px 20px;
  border-radius: 8px;
  color: #fff;
  text-transform: uppercase;
  display: inline-block;
}

.register-form {
  background-size: cover;
  background: rgba(0, 0, 0, 0.9) url('/img/login_form_bg.png') no-repeat center;
  min-height: 100vh;
}
</style>
